export default __webpack_public_path__ + "static/media/person_black.cee3191a.svg";